var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 19V22H2V19C2 18.45 2.45 18 3 18H21C21.55 18 22 18.45 22 19Z",
    fill: "#02BAF1",
    stroke: "#02BAF1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 17.5V11.5H6.5V17.5H5.5Z",
    fill: "#02BAF1",
    stroke: "#02BAF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.5V11.5H10.5V17.5H9.5Z",
    fill: "#02BAF1",
    stroke: "#02BAF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.5V11.5H14.5V17.5H13.5Z",
    fill: "#02BAF1",
    stroke: "#02BAF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5V11.5H18.5V17.5H17.5Z",
    fill: "#02BAF1",
    stroke: "#02BAF1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22.25H1C0.866142 22.25 0.75 22.1339 0.75 22C0.75 21.8661 0.866142 21.75 1 21.75H23C23.1339 21.75 23.25 21.8661 23.25 22C23.25 22.1339 23.1339 22.25 23 22.25Z",
    fill: "#02BAF1",
    stroke: "#02BAF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1843 2.61408L21.1843 6.21408C21.2504 6.2405 21.3341 6.30479 21.4026 6.40575C21.4711 6.50661 21.5 6.60799 21.5 6.67984V9.99984C21.5 10.2737 21.2739 10.4998 21 10.4998H3C2.72614 10.4998 2.5 10.2737 2.5 9.99984V6.67984C2.5 6.60799 2.52889 6.50661 2.59739 6.40575C2.66594 6.30479 2.74964 6.2405 2.8157 6.21408L11.8157 2.61408C11.8375 2.60534 11.9042 2.58984 12 2.58984C12.0958 2.58984 12.1625 2.60534 12.1843 2.61408ZM10 6.99984C10 8.10599 10.8939 8.99984 12 8.99984C13.1061 8.99984 14 8.10599 14 6.99984C14 5.8937 13.1061 4.99984 12 4.99984C10.8939 4.99984 10 5.8937 10 6.99984Z",
    fill: "#02BAF1",
    stroke: "#02BAF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.8f245a8ede7cd2e1836963e1c0e414b8.svg";
export { ForwardRef as ReactComponent };